module.exports = __webpack_public_path__ + "img/p4_2.dfb2ce41.png";